import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Container,
  Spinner,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import showNotification from "../../helpers/show_notification";
import { postSubmitForm } from "../../helpers/forms_helper";

const AddLocation = (props) => {

  useEffect(() => {
    loadAllLocations();
  }, []);

  const [allLocations, setAllLocations] = useState([]);
  const loadAllLocations = async () => {
    let url = process.env.REACT_APP_BASEURL + "locations/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllLocations(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const refContainer = useRef(null);
  const [isLoading, setIsLoading] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
      setIsLoading(true)
      let url = process.env.REACT_APP_BASEURL + "locations/insert";
      let response = await postSubmitForm(url, v);
      if (response.status === 1) {
        loadAllLocations();
        showNotification(response.message, "Success");
        refContainer.current.reset();
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    }finally{
      setIsLoading(false)
    }
  };

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "1%" };
      },
    },
    {
      text: props.t("Location Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "16%" };
      },
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Location")}
            breadcrumbItem={props.t("Add Location")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleValidSubmit} ref={refContainer}>
                    <CardTitle>{props.t("Add Location")}</CardTitle>
                    <CardSubtitle className="mb-3">
                      {props.t("Enter the following details to add a new location")}
                    </CardSubtitle>
                    <Row>
                      <Col lg={4} md={4}>
                        <AvField
                          name="name"
                          label={props.t("Location")}
                          placeholder={props.t("Enter Location Name")}
                          type="text"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: props.t("Name cannot be empty"),
                            },
                          }}
                        />
                      </Col>
                      

                      <Col lg={8} md={8}>
                        <div className="mt-4 ">
                            <Button type="submit" disabled={isLoading} style={{width:"100px"}} color="primary">
                              {isLoading ? <Spinner size="sm"/> : props.t("Submit")}
                            </Button>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("Existing Locations")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all your existing locations here")}
                  </CardSubtitle>
                  <BootstrapTable
                    bootstrap4
                    keyField="_id"
                    data={allLocations && allLocations}
                    columns={columns}
                    noDataIndication={props.t("No data to display.")}
                    striped
                    hover
                    condensed
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(
  connect(null, {})(withNamespaces()(AddLocation))
);
